import { ElAffix } from '@park-ui/components/affix'
import { ElAlert } from '@park-ui/components/alert'
import { ElAutocomplete } from '@park-ui/components/autocomplete'
import { ElAvatar } from '@park-ui/components/avatar'
import { ElBacktop } from '@park-ui/components/backtop'
import { ElBadge } from '@park-ui/components/badge'
import { ElBreadcrumb, ElBreadcrumbItem } from '@park-ui/components/breadcrumb'
import { ElButton, ElButtonGroup } from '@park-ui/components/button'
import { ElCalendar } from '@park-ui/components/calendar'
import { ElCard } from '@park-ui/components/card'
import { ElCarousel, ElCarouselItem } from '@park-ui/components/carousel'
import { ElCascader } from '@park-ui/components/cascader'
import { ElCascaderPanel } from '@park-ui/components/cascader-panel'
import { ElCheckTag } from '@park-ui/components/check-tag'
import {
  ElCheckbox,
  ElCheckboxButton,
  ElCheckboxGroup,
} from '@park-ui/components/checkbox'
import { ElCol } from '@park-ui/components/col'
import { ElCollapse, ElCollapseItem } from '@park-ui/components/collapse'
import { ElCollapseTransition } from '@park-ui/components/collapse-transition'
import { ElColorPicker } from '@park-ui/components/color-picker'
import { ElConfigProvider } from '@park-ui/components/config-provider'
import {
  ElAside,
  ElContainer,
  ElFooter,
  ElHeader,
  ElMain,
} from '@park-ui/components/container'
import { ElDatePicker } from '@park-ui/components/date-picker'
import {
  ElDescriptions,
  ElDescriptionsItem,
} from '@park-ui/components/descriptions'
import { ElDialog } from '@park-ui/components/dialog'
import { ElDivider } from '@park-ui/components/divider'
import { ElDrawer } from '@park-ui/components/drawer'
import {
  ElDropdown,
  ElDropdownItem,
  ElDropdownMenu,
} from '@park-ui/components/dropdown'
import { ElEmpty } from '@park-ui/components/empty'
import { ElForm, ElFormItem } from '@park-ui/components/form'
import { ElIcon } from '@park-ui/components/icon'
import { ElImage } from '@park-ui/components/image'
import { ElImageViewer } from '@park-ui/components/image-viewer'
import { ElInput } from '@park-ui/components/input'
import { ElInputNumber } from '@park-ui/components/input-number'
import { ElLink } from '@park-ui/components/link'
import { ElMenu, ElMenuItem, ElMenuItemGroup } from '@park-ui/components/menu'
import { ElPageHeader } from '@park-ui/components/page-header'
import { ElPagination } from '@park-ui/components/pagination'
import { ElPopconfirm } from '@park-ui/components/popconfirm'
import { ElPopover } from '@park-ui/components/popover'
import { ElPopper } from '@park-ui/components/popper'
import { ElProgress } from '@park-ui/components/progress'
import { ElRadio, ElRadioButton, ElRadioGroup } from '@park-ui/components/radio'
import { ElRate } from '@park-ui/components/rate'
import { ElResult } from '@park-ui/components/result'
import { ElRow } from '@park-ui/components/row'
import { ElScrollbar } from '@park-ui/components/scrollbar'
import { ElOption, ElOptionGroup, ElSelect } from '@park-ui/components/select'
import { ElSelectV2 } from '@park-ui/components/select-v2'
import { ElSkeleton, ElSkeletonItem } from '@park-ui/components/skeleton'
import { ElSlider } from '@park-ui/components/slider'
import { ElSpace } from '@park-ui/components/space'
import { ElStep, ElSteps } from '@park-ui/components/steps'
import { ElSwitch } from '@park-ui/components/switch'
import { ElTable, ElTableColumn } from '@park-ui/components/table'
import { ElAutoResizer, ElTableV2 } from '@park-ui/components/table-v2'
import { ElTabPane, ElTabs } from '@park-ui/components/tabs'
import { ElTag } from '@park-ui/components/tag'
import { ElTimePicker } from '@park-ui/components/time-picker'
import { ElTimeSelect } from '@park-ui/components/time-select'
import { ElTimeline, ElTimelineItem } from '@park-ui/components/timeline'
import { ElTooltip } from '@park-ui/components/tooltip'
import { ElTooltipV2 } from '@park-ui/components/tooltip-v2'
import { ElTransfer } from '@park-ui/components/transfer'
import { ElTree } from '@park-ui/components/tree'
import { ElTreeSelect } from '@park-ui/components/tree-select'
import { ElTreeV2 } from '@park-ui/components/tree-v2'
import { ElUpload } from '@park-ui/components/upload'
// custom components
// import { ElCigInput } from '@park-ui/components/cig-input'
// import { ElCigButton } from '@park-ui/components/cig-button'
// import { ElCigForm } from '@park-ui/components/cig-form'
import { ElCigBreadcrumb } from '@park-ui/components/cig-breadcrumb'
import { ElCigTree } from '@park-ui/components/cig-tree'
import { ElCigSearch } from '@park-ui/components/cig-search'
import { ElCigDialog } from '@park-ui/components/cig-dialog'
import { ElCigTable } from '@park-ui/components/cig-table'
import { ElCigMap } from '@park-ui/components/cig-map'
import { ElCigSelect } from '@park-ui/components/cig-select'

import CigIcon from '@park-ui/components/cig-icon'

import type { Plugin } from 'vue'

export default [
  ElAffix,
  ElAlert,
  ElAutocomplete,
  ElAutoResizer,
  ElAvatar,
  ElBacktop,
  ElBadge,
  ElBreadcrumb,
  ElBreadcrumbItem,
  ElButton,
  ElButtonGroup,
  ElCalendar,
  ElCard,
  ElCarousel,
  ElCarouselItem,
  ElCascader,
  ElCascaderPanel,
  ElCheckTag,
  ElCheckbox,
  ElCheckboxButton,
  ElCheckboxGroup,
  ElCol,
  ElCollapse,
  ElCollapseItem,
  ElCollapseTransition,
  ElColorPicker,
  ElConfigProvider,
  ElContainer,
  ElAside,
  ElFooter,
  ElHeader,
  ElMain,
  ElDatePicker,
  ElDescriptions,
  ElDescriptionsItem,
  ElDialog,
  ElDivider,
  ElDrawer,
  ElDropdown,
  ElDropdownItem,
  ElDropdownMenu,
  ElEmpty,
  ElForm,
  ElFormItem,
  ElIcon,
  ElImage,
  ElImageViewer,
  ElInput,
  ElInputNumber,
  ElLink,
  ElMenu,
  ElMenuItem,
  ElMenuItemGroup,
  ElPageHeader,
  ElPagination,
  ElPopconfirm,
  ElPopover,
  ElPopper,
  ElProgress,
  ElRadio,
  ElRadioButton,
  ElRadioGroup,
  ElRate,
  ElResult,
  ElRow,
  ElScrollbar,
  ElSelect,
  ElOption,
  ElOptionGroup,
  ElSelectV2,
  ElSkeleton,
  ElSkeletonItem,
  ElSlider,
  ElSpace,
  ElSteps,
  ElStep,
  ElSwitch,
  ElTable,
  ElTableColumn,
  ElTableV2,
  ElTabs,
  ElTabPane,
  ElTag,
  ElTimePicker,
  ElTimeSelect,
  ElTimeline,
  ElTimelineItem,
  ElTooltip,
  ElTooltipV2,
  ElTransfer,
  ElTree,
  ElTreeSelect,
  ElTreeV2,
  ElUpload,
  // custom components
  ElCigMap,
  ElCigBreadcrumb,
  ElCigTree,
  ElCigSearch,
  ElCigDialog,
  ElCigSelect,
  ElCigTable,
  CigIcon,
] as Plugin[]
